<template>
  <section class="section">
    <div class="container">
      <div class="mb-8">
        <div class="title is-4 has-text-primary uppercase mb-4">
          Configuration de la baie de brassage
        </div>
        <b-button
          type="is-text"
          class="button-bold"
          tag="router-link"
          :to="getConfigurationPath('/configuration')"
        >
          Revenir à la configuration
        </b-button>
      </div>


      <p class="flex justify-center mb-4 has-text-primary title is-5">
        Choisissez un espace de réserve pour améliorer les recommandations :
      </p>
      <div class="flex justify-center mb-12">
        <b-select v-model="reserveUnit">
          <option
            v-for="option in reserveTypes"
            :key="option.id"
            :value="option.id"
          >
            {{ option.text }}
          </option>
        </b-select>
        <b-input
          v-if="reserveUnit === 'U'"
          v-model="reserveValue"
          type="number"
          step="1"
          class="w-32 ml-2"
          :placeholder="suggestedReserveValue"
        />
        <b-input
          v-if="reserveUnit === 'percentage'"
          v-model="reserveValue"
          type="number"
          class="w-32 ml-2"
          min="0"
          max="100"
          step="1"
          :placeholder="20"
        />
      </div>

      <div
        v-if="suggestedBaie || suggestedCoffret"
        class="flex justify-center has-text-primary title is-5"
      >
        Le conseil uniformatic en rapport avec votre configuration :
      </div>
      <div class="columns text-center flex justify-around">
        <div
          v-if="totalConfigurationSize <= 22 && suggestedCoffret"
          class="column is-half"
        >
          <p class="has-text-primary">
            Coffret
          </p>
          <p class="mb-2">
            Pour accrocher au mur
          </p>
          <BaseCard
            :card-title="suggestedCoffret.designation"
            :text-lines="productTextAttributes(suggestedCoffret)"
            :image-url="suggestedCoffret.photo_url"
          >
            <div class="flex items-end">
              <b-button
                type="is-primary"
                :disabled="container"
                @click="chooseContainer(suggestedCoffret)"
              >
                Choisir
              </b-button>
            </div>
          </BaseCard>
        </div>

        <div
          v-if="suggestedBaie"
          class="column is-half"
        >
          <p class="has-text-primary">
            Baie
          </p>
          <p class="mb-2">
            Pour poser au sol
          </p>
          <BaseCard
            :card-title="suggestedBaie.designation"
            :text-lines="productTextAttributes(suggestedBaie)"
            :image-url="suggestedBaie.photo_url"
          >
            <div class="flex items-end">
              <b-button
                type="is-primary"
                :disabled="container"
                @click="chooseContainer(suggestedBaie)"
              >
                Choisir
              </b-button>
            </div>
          </BaseCard>
        </div>
      </div>

      <div class="block text-center">
        <p class="text-xl has-text-primary mb-4">
          Vous avez un produit défini dans votre CCTP ? Vous avez une contrainte de hauteur ?
          Vous savez très exactement ce que vous souhaitez ?
        </p>
        <b-button
          class="is-info"
          tag="router-link"
          :to="getConfigurationPath('/choix-baie')"
        >
          Afficher tous les produits
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  ceil, filter, minBy,
} from 'lodash';
import BaseCard from '@/components/BaseCard.vue';
import configurationMixin from './mixins/configurationMixin';
import containerChoiceMixin from './mixins/containerChoiceMixin';

export default {
  name: 'ContainerSuggestion',
  components: { BaseCard },
  mixins: [configurationMixin, containerChoiceMixin],
  data() {
    return {
      reserveTypes: [
        {
          id: 'U',
          text: 'En U',
        },
        {
          id: 'percentage',
          text: 'En %',
        },
      ],
      reserveUnit: 'U',
      reserveValue: undefined,
    };
  },
  computed: {
    ...mapGetters('configuration', ['configurationSize', 'filterProductsByType', 'suggestedBaie',
      'container']),
    suggestedReserveValue() {
      return ceil(this.configurationSize * 0.2);
    },
    totalConfigurationSize() {
      let reserve = this.suggestedReserveValue;
      if (this.reserveValue) {
        const value = parseInt(this.reserveValue, 10);
        if (this.reserveUnit === 'U') {
          reserve = value;
        } else if (this.reserveValue >= 0 && this.reserveValue <= 100) {
          reserve = this.configurationSize * (this.reserveValue / 100);
        }
      }

      return reserve + this.configurationSize;
    },
    suggestedCoffret() {
      const coffrets = this.filterProductsByType('Coffret');
      return minBy(filter(coffrets, (coffret) => coffret.taille >= this.totalConfigurationSize), 'taille');
    },
  },
};
</script>
